import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TablePagination,
  Typography,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import axios from "axios";
import configServ from "../../services/config";

const UserLogHistory = () => {
  const [userLog, setUserLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchUserLog = async () => {
    setLoading(true);
    try {
      const dataToSend = {
        rowsPerPage: rowsPerPage,
        page: page + 1, // Laravel 1-based indexing use karta hai
      };
      const res = await configServ.getAllUserHistory(dataToSend); // POST method se request bhejna
      if (res.success === true) {
        setUserLog(res.data);
        setTotalRecords(res.total); // Total records ko update karna
      }
    } catch (error) {
      console.error("Error fetching user logs:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserLog(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"User Log"}
        showCreate={false}
      />
      <TableContainer
        component={Paper}
        sx={{ mt: 2, display: { xs: "none", md: "table" } }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#4cb5f5" }}>
              <TableCell sx={{ color: "white" }}>S.No.</TableCell>
              <TableCell sx={{ color: "white" }}>Customer Name</TableCell>
              <TableCell sx={{ color: "white" }}>Location</TableCell>
              <TableCell sx={{ color: "white" }}>Login Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : userLog.length > 0 ? (
              userLog.map((log, index) => (
                <motion.tr
                  key={log.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                >
                  <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                  <TableCell>{log.cust_name}</TableCell>
                  <TableCell>{log.location}</TableCell>
                  <TableCell>{log.login_time}</TableCell>
                </motion.tr>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mobile View - Card Style */}
      <Box sx={{ display: { xs: "block", md: "none" }, p: 2 }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100px"
          >
            <CircularProgress />
          </Box>
        ) : userLog.length > 0 ? (
          userLog.map((log, index) => (
            <Paper key={log.id} sx={{ p: 2, mb: 2, boxShadow: 3 }}>
              <Typography variant="h6">
                SNo: {index + 1 + page * rowsPerPage}
              </Typography>
              <Typography>
                <strong>Customer:</strong> {log.cust_name}
              </Typography>
              <Typography>
                <strong>Location:</strong> {log.location}
              </Typography>
              <Typography>
                <strong>Login Time:</strong> {log.login_time}
              </Typography>
            </Paper>
          ))
        ) : (
          <Typography align="center">No Data Found</Typography>
        )}
      </Box>

      <TablePagination
        component="div"
        count={totalRecords}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </>
  );
};

export default UserLogHistory;
